
























































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import RestClient, { RestError, ServerError } from "../RestClient";
import DemoServer from "../shared/DemoServer";
import Utils from "../shared/Utils";
import DateFormatter from "../shared/DateFormatter";

import Loading from "../components/general/Loading.vue";
import TextView from "../components/controls/TextView.vue";
import ApprovalList from "../components/controls/ApprovalList.vue";

import { GroupBookingStatus } from "../shared/GroupBookingStatus";
import GroupBookingInfoJson from "../shared/GroupBookingInfoJson";
import GroupBookingJson, { getGroupBookingRequestMinDate } from "../shared/GroupBookingJson";

import CustomerJson, { defaultCustomerJson } from "../shared/CustomerJson";
import SepaMandateJson from "../shared/SepaMandateJson";

import { Gender } from "../shared/Gender";
import { validateGroupBookingJsonBookingForm } from "../shared/GroupBookingJson";
import { ValidationResult, Validation } from "../shared/Validation";

import CustomContent from "../components/custom/GroupsRegistration";

type keysForCachedData = {
  [key in keyof Pick<GroupBookingJson, "desiredDateTime" | "beginDateTime" | "endDateTime">]: string;
};

export default Vue.extend({
  name: "gruppenangebote",
  components: {
    Loading,
    TextView,
    ApprovalList,
  },
  data() {
    return {
      RestClient: RestClient,
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      Gender: Gender,
      CustomContent: CustomContent,
      supportsDatePicker: false,
      defaultGroupBookingHours: {
        halfDay: 3,
        wholeDay: 6,
      },
      urlParams: null as URLSearchParams | null,
      embeddedStyle: false as boolean,
      groupBookingInfo: null as GroupBookingInfoJson | null,
      bookingDetails: null as GroupBookingJson | null,
      cachedDates: {
        desiredDateTime: "",
      } as keysForCachedData,
      cachedTimes: {
        desiredDateTime: "",
      } as keysForCachedData,
      showHints: {
        desiredTime: false as boolean,
      },
      validation: null as ValidationResult<GroupBookingJson> | null,
      toValidate: {} as any,
      submitValidation: false,
      useSepeMandate: true,
      differentAddress: false,
      showValidationWarnung: false as boolean,
      submitLoading: false as boolean,
      submitSuccess: false as boolean,
      inquiryResult: "" as string,
    };
  },
  created() {
    this.getUrlParams();
    this.initBooking();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    getUrlParams() {
      this.urlParams = new URL(location.href).searchParams;
    },

    async initBooking() {
      await this.loadGroupBookingInfo();
      await this.loadGroupBookingDetails();

      if (this.urlParams != null) {
        this.embeddedStyle = Utils.getUrlParamBool(this.urlParams.get("embedded"));
      }
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>document.querySelector("#testDatePicker input");

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadGroupBookingInfo() {
      try {
        this.groupBookingInfo = await this.RestClient.getGroupBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadGroupBookingDetails() {
      this.bookingDetails = {
        ID: null,
        desiredDateTime: "",
        beginDateTime: "",
        endDateTime: "",
        remarks: "",
        isLunchIncluded: false,
        lunchPortionAmount: null,
        isWholeDay: false,
        staffId: null,
        customer: this.getDefaultCustomer(),
        state: GroupBookingStatus.requested,
        programTitle: "",
        programDescription: "",
        estimatedChildrenCount: 1,
        estimatedChildrenAge: "",
        price: 0,
        cancellationFee: 0,
        cancellationRemarks: "",
        cancellationReason: "",
        sepaMandate: this.getDefaultSepaMandate(),
        invoiceInfos: null,
      };
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      return {
        ID: null,
        dateTime: new Date().toISOString(),
        lastUseDateTime: new Date().toISOString(),
        accountHolderFirstName: "",
        accountHolderLastName: "",
        addressStreet: "",
        addressZip: "",
        addressCity: "",
        addressCountry: "Deutschland",
        IBAN: "",
        BIC: "",
      };
    },

    toggleUseSepaMandate() {
      if (this.bookingDetails != null) {
        if (this.useSepeMandate) {
          this.bookingDetails.sepaMandate = this.getDefaultSepaMandate();
        } else {
          this.bookingDetails.sepaMandate = null;
        }
      }
    },

    formatCachedDateTimeAndSet(key: keyof keysForCachedData) {
      if (this.bookingDetails != null) {
        //date
        if (this.cachedDates[key] != "") {
          let date = "";

          if (this.supportsDatePicker) {
            date = DateFormatter.formatUSDate(new Date(this.cachedDates[key]));
          } else {
            if (this.cachedDates[key].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedDates[key]);

              if (d != null) {
                date = DateFormatter.formatUSDate(d);
              }
            }
          }

          //time
          let time = this.cachedTimes[key].replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

          //if (time.match(/^\d{2,2}:\d{2,2}$/g)) {
          this.cachedTimes[key] = time;

          if (isNaN(new Date(date).getTime())) {
            //no valid date
            this.bookingDetails[key] = "";
          } else {
            this.showHints.desiredTime = false;

            let dateTime = new Date(date);

            if (this.cachedTimes[key] != "") {
              //let time = DateFormatter.formatTime(new Date(this.workshopDetails.registrationBeginDateTime))

              dateTime = new Date(date + " " + this.cachedTimes[key]);
            } else {
              dateTime.setHours(8);
            }

            this.bookingDetails[key] = DateFormatter.formatISODateTime(dateTime);
            this.cachedTimes[key] = DateFormatter.formatTime(new Date(this.bookingDetails[key]));
          }
        } else {
          this.cachedTimes[key] = "";
          this.showHints.desiredTime = true;
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.bookingDetails != null) {
        this.validation = validateGroupBookingJsonBookingForm(this.bookingDetails, 0);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    checkAprovals() {
      var check = true;

      if (this.useSepeMandate) {
        check = (this.$refs.approvalSepa as any).validate();
        if (!check) return check;
      }

      check = (this.$refs.approvalRequired as any).validate();

      return check;
    },

    async submitForm() {
      if (this.bookingDetails != null) {
        this.submitLoading = true;

        //set begin and end dateTime
        this.setBeginAndEndDateTime();

        //set different address
        if (!this.differentAddress) {
          this.setDifferentAddress();
        }

        //add dateTime to sepa mandate
        if (this.bookingDetails.sepaMandate != null) {
          let now = new Date().toISOString();
          this.bookingDetails.sepaMandate.dateTime = now;
        }

        //final validation
        this.validation = validateGroupBookingJsonBookingForm(this.bookingDetails, 0);
        this.submitValidation = true;

        //start submit if aprovals and validation is correct
        if (this.checkAprovals() && this.validation != null && this.validation.isValid == true) {
          try {
            let result = await this.RestClient.requestGroupBooking(this.bookingDetails);
            this.submitSuccess = true;
            this.submitLoading = false;
          } catch (e) {
            alert(e.message);
            this.submitLoading = false;
          }
        } else {
          this.showValidationWarnung = true;
          this.submitLoading = false;
        }
      }
    },

    setBeginAndEndDateTime() {
      if (this.bookingDetails != null) {
        //set beginDateTime
        this.bookingDetails.beginDateTime = this.bookingDetails.desiredDateTime;

        //set endDateTime
        const beginDateTimeDate = new Date(this.bookingDetails.desiredDateTime);

        var durationTime = 0;
        if (this.bookingDetails.isWholeDay) {
          durationTime = this.defaultGroupBookingHours.wholeDay;
        } else {
          durationTime = this.defaultGroupBookingHours.halfDay;
        }

        let beginHours = beginDateTimeDate.getHours();
        let endDateTimeDate = beginDateTimeDate.setHours(beginHours + durationTime);

        this.bookingDetails.endDateTime = DateFormatter.formatISODateTime(new Date(endDateTimeDate));
      }
    },

    setLunchPortionAmount() {
      if (this.bookingDetails != null) {
        if (this.bookingDetails.isLunchIncluded) {
          this.bookingDetails.lunchPortionAmount = this.bookingDetails.estimatedChildrenCount;
        } else {
          this.bookingDetails.lunchPortionAmount = null;
        }
      }
    },

    setDifferentAddress() {
      if (this.bookingDetails != null) {
        if (this.bookingDetails.customer != null && this.bookingDetails.sepaMandate != null) {
          this.bookingDetails.sepaMandate.accountHolderFirstName = this.bookingDetails.customer.guardianFirstName;
          this.bookingDetails.sepaMandate.accountHolderLastName = this.bookingDetails.customer.guardianLastName;

          this.bookingDetails.sepaMandate.addressStreet = this.bookingDetails.customer.addressStreet;
          this.bookingDetails.sepaMandate.addressZip = this.bookingDetails.customer.addressZip;
          this.bookingDetails.sepaMandate.addressCity = this.bookingDetails.customer.addressCity;
          this.bookingDetails.sepaMandate.addressCountry = this.bookingDetails.customer.addressCountry;
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {},

  computed: {
    bookingMinDateISO(): string {
      return DateFormatter.formatISODate(
        getGroupBookingRequestMinDate(this.groupBookingInfo?.groupBookingCanRequestUntilDaysAhead ?? 1)
      );
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            return this.bookingDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.bookingDetails != null) {
          if (this.bookingDetails.sepaMandate != null) {
            this.bookingDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
